/** 轻量 toast：用于图片加载失败等友好提示。 */

let toastEl: HTMLDivElement | null = null;
let timer = 0;

function ensure(): HTMLDivElement {
  if (!toastEl) {
    toastEl = document.createElement('div');
    toastEl.className = 'pintu-toast';
    toastEl.setAttribute('role', 'status');
    document.body.appendChild(toastEl);
  }
  return toastEl;
}

export function showToast(msg: string, ms = 2500): void {
  const el = ensure();
  el.textContent = msg;
  el.classList.add('show');
  window.clearTimeout(timer);
  timer = window.setTimeout(() => el.classList.remove('show'), ms);
}
